import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ClipchampPlayer } from '@bingads-webui-campaign-react/clipchamp-player';
import { getMultiAdVideoPreviewStyles } from '../styles/multi-ad-video-preview-styles';

export const MultiAdVideoPreview = (props) => {
  const {
    i18n,
    data = { videos: [] },
    selectedVideoIdx = '',
    loadClipchampPlayer,
    permissions,
  } = props;

  const [selectedVideo, setSelectedVideo] = useState(null);
  const videoRef = useRef();

  useEffect(() => {
    if (data.videos && selectedVideoIdx !== '') {
      const video = data.videos[selectedVideoIdx];
      setSelectedVideo(video);
    } else {
      setSelectedVideo(null);
    }
  }, [data, selectedVideoIdx]);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, [selectedVideo]);

  const classes = useDefaultStyles(getMultiAdVideoPreviewStyles);
  const source = selectedVideo ? selectedVideo.src : '';
  const videoTemplateUIEnabled = permissions && permissions.dynamic && permissions.dynamic.VideoTemplateUI;

  return (
    <div className={classes.adPreviewRoot}>
      <div className={classes.adPreviewHeader}>
        <Text className={classes.adPreviewTitle}>
          {i18n.getString(_TL_('Ad preview'))}
        </Text>
      </div>
      <div className={classes.previewContainer}>
        {videoTemplateUIEnabled ? (
          <ClipchampPlayer videoUrl={source} width="100%" loadClipchampPlayer={loadClipchampPlayer} />
        ) : (
          <video className={classes.video} controls ref={videoRef}>
            <source src={source} />
            <track
              kind="captions"
              src=""
              srcLang="en"
              label="English"
              default
            />
          </video>
        )}
      </div>
      <div className={classes.previewTag}>
        <Text>
          {i18n.getString(_TL_('This is an example of what your video ad might look like. Depending on placement, the actual ad shown may appear differently.'))}
        </Text>
      </div>
    </div>
  );
};

MultiAdVideoPreview.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  selectedVideoIdx: PropTypes.string,
  data: PropTypes.shape({
    data: PropTypes.instanceOf(Array),
  }).isRequired,
};

MultiAdVideoPreview.defaultProps = {
  selectedVideoIdx: null,
};
